import { getOriginUrl } from '../../utils/url-utils';

export interface GetCanonicalUrlProps {
    c_pageURL?: string;
    c_canonicalProductId?: string;
    c_gcType?: string;
}
export const getCanonicalUrl = ({
    c_pageURL,
    c_canonicalProductId,
}: GetCanonicalUrlProps): string => {
    const originUrl = getOriginUrl();

    return `${originUrl}/product/${c_pageURL}/${c_canonicalProductId}`;
};

export const getCanonicalUrlForGC = ({
    c_canonicalProductId,
    c_gcType,
}: GetCanonicalUrlProps): string => {
    const originUrl = getOriginUrl();
    const gcUrlType = c_gcType === 'physical' ? 'traditional-gift-card' : 'electronic-gift-cards';

    return `${originUrl}/product/${gcUrlType}/${c_canonicalProductId}`;
};
